function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Logger from "./Logger.js";
import { INFO } from "./LoggerLevel.js";
class DefaultLogger extends Logger {
  constructor() {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INFO;
    super(null, level);
    _defineProperty(this, "modules", void 0);
    this.modules = {};
  }
  module(name) {
    if (this.modules[name] == null) {
      this.modules[name] = new Logger(name, this.level);
    }
    return this.modules[name];
  }
  setLogLevel(level) {
    super.setLogLevel(level);
    if (this.modules == null) {
      return;
    }
    var keys = Object.keys(this.modules);
    for (var i = 0; i < keys.length; i += 1) {
      this.modules[keys[i]].setLogLevel(level);
    }
  }
}
export default DefaultLogger;
//# sourceMappingURL=DefaultLogger.js.map